import React from "react";

const LoadingScreen = () => (
  <div className="activation-page__card">
    <div className="activation-page__spinner" />
  </div>
);

export default LoadingScreen;
